/** Id des <form>-Elements — erlaubt einen Speichern-Button ausserhalb des Formulars. */
export const LIMIT_FORM_ID = "limit-editor-form";
